/**
 * Compares if two objects are equal in values (recursive in the case of child objects).
 *
 * @param object1 first object
 * @param object2 second object
 * @returns {boolean} true if they are equal in values, or else false
 */
export const deepEquals = (
  object1: { [x: string]: any },
  object2: { [x: string]: any }
): boolean => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEquals(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

export const isObject = (object: any | null): boolean => {
  return !!object && typeof object === 'object';
};

export const nameof = <T>(name: keyof T) => name.toString();

/**
 * Überprüft ob ein Element aus dem Fenster steht.
 * @param  {Node}  elem Element zur Überprüfung
 * @return {Object}    Object mit booleans für jede Seite
 */
export const isOutOfViewport = (elem: any) => {
  const bounding = elem.getBoundingClientRect();
  const out = {
    top: false,
    left: false,
    bottom: false,
    right: false,
    any: false,
  };
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom =
    bounding.bottom >
    (window.innerHeight || document.documentElement.clientHeight);
  out.right =
    bounding.right >
    (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;

  return out;
};

export const booleanToString = (value: boolean | undefined) => {
  return value ? 'true' : 'false';
};
